import { getStockTypeLabels } from '@app/ducks';
import { isNull } from '@app/utils/is';
import { DeliveryWindow } from '@typings';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

interface Props {
  deliveryWindow: DeliveryWindow.DeliveryWindowsSearchItem;
  isRunning?: boolean;
  deliveryPeriod: string | null;
  saleEndDate: string | null;
}

export const DelwinMenuItemTooltipContent = React.memo(({ deliveryWindow, isRunning, deliveryPeriod, saleEndDate }: Props) => {
  const { t } = useTranslation(['common']);
  const stockTypeLabel = useSelector(getStockTypeLabels)[deliveryWindow.stockType];

  return (
    <div className="grid grid-cols-2 gap-x-3 gap-y-1 body-5">
      {isRunning ?
        <>
          <span>{t('common:stock_type')}</span>
          <span className="body-4">{stockTypeLabel}</span>
          <span className="col-span-2 body-4">{t('common:ongoing_delivery')}</span>
        </>
      : <>
          <span>{t('common:stock_type')}</span>
          <span className="body-4">{stockTypeLabel}</span>
          {!isNull(deliveryPeriod) && (
            <>
              <span>{t('common:delivery_dates')}</span>
              <span className="body-4">{deliveryPeriod}</span>
            </>
          )}
          {!isNull(saleEndDate) && (
            <>
              <span>{t('common:sale_end_date')}</span>
              <span className="body-4">{saleEndDate}</span>
            </>
          )}
        </>
      }
    </div>
  );
});
